import { render, staticRenderFns } from "./StandingsTable.vue?vue&type=template&id=0d007756&scoped=true&"
import script from "./StandingsTable.vue?vue&type=script&lang=js&"
export * from "./StandingsTable.vue?vue&type=script&lang=js&"
import style0 from "./StandingsTable.vue?vue&type=style&index=0&id=0d007756&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d007756",
  null
  
)

export default component.exports